import React from 'react';
import { useSelector } from 'react-redux';

import './SellTransactionEstimation.scss';

import {
  getDirectDepositTimelines,
  getExpressDeliveryTimelines,
  getMailACheckTimelines,
} from '../../../../redux/modules/sellTransaction/sellTransaction.selectors';
import {
  DELIVERY_DIRECT_DEPOSIT,
  DELIVERY_EXPRESS_DELIVERY,
  DELIVERY_MAIL_CHECK,
  DELIVERY_MAIL_CHECK_QCD,
  DELIVERY_MAIL_CHECK_TO_CHARITY,
  DELIVERY_MAIL_CHECK_TO_SCHOOL,
} from '../../../../settings/settings';
import If from '../../../Shared/If/If';
import { formatUTCDate } from '../../../../utils/dates/date-utility';
import { isAppSell } from 'src/utils/transactions-util';

const SellTransactionEstimation = ({ isMobile = false, deliveryMethod }) => {
  const directDepositTimeLines = useSelector(getDirectDepositTimelines);
  const expressDeliveryTimeLines = useSelector(getExpressDeliveryTimelines);
  const mailACheckTimeLines = useSelector(getMailACheckTimelines);
  return (
    <div
      className={` ${
        isMobile ? 'hidden-lg hidden-md hidden-sm' : 'hidden-xs'
      } sell-transaction-estimation-date`}
    >
      Est. Delivery Date:
      <span className="sell-transaction-estimation-dates">
        <If
          test={
            deliveryMethod === 'DIRECT DEPOSIT' ||
            deliveryMethod === DELIVERY_DIRECT_DEPOSIT
          }
        >
          {isAppSell() ? (
            <>2-3 days from trade date</>
          ) : (
            <>
              {formatUTCDate(directDepositTimeLines.minimum, 'MM/DD/YY')} -{' '}
              {formatUTCDate(directDepositTimeLines.maximum, 'MM/DD/YY')}
            </>
          )}
        </If>
        <If
          test={
            deliveryMethod === 'WIRE TRANSFER' ||
            deliveryMethod === DELIVERY_EXPRESS_DELIVERY
          }
        >
          {isAppSell() ? (
            <>1-2 days from trade date</>
          ) : (
            <>
              {formatUTCDate(expressDeliveryTimeLines.minimum, 'MM/DD/YY')} -{' '}
              {formatUTCDate(expressDeliveryTimeLines.maximum, 'MM/DD/YY')}
            </>
          )}
        </If>
        <If
          test={
            deliveryMethod === 'MAIL CHECK TO' ||
            deliveryMethod === DELIVERY_MAIL_CHECK ||
            deliveryMethod === DELIVERY_MAIL_CHECK_TO_SCHOOL ||
            deliveryMethod === DELIVERY_MAIL_CHECK_QCD ||
            deliveryMethod === DELIVERY_MAIL_CHECK_TO_CHARITY
          }
        >
          {isAppSell() ? (
            <>7-10 days from trade date</>
          ) : (
            <>
              {formatUTCDate(mailACheckTimeLines.minimum, 'MM/DD/YY')} -{' '}
              {formatUTCDate(mailACheckTimeLines.maximum, 'MM/DD/YY')}
            </>
          )}
        </If>
      </span>
    </div>
  );
};

export default SellTransactionEstimation;
